// extracted by mini-css-extract-plugin
export default {"fieldLabel":"data-download_fieldLabel__LMwYQ"};